<template>
    <div class="costOriginValueManage">
      <router-view></router-view>
    </div>
</template>



<script>
export default {
  name: "costOriginValueManage",
  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
    
</style>
